import React from "react"
import PropTypes from "prop-types"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

const DefaultColumnSortingIndicator =
    ({
        columnId,
        id,
        defaultSortType,
        toggleDefaultSortOnColumn,
    }) => {
        const currentSortType = DjangIO.app.userdata.spreadsheet.types.SheetSortType.by_value(defaultSortType)
        const handleClick = () => toggleDefaultSortOnColumn(id, columnId, currentSortType.next_public_sort_type)
        return (
            <Tooltip label={currentSortType.public_tooltip}>
                <Icon
                    name={currentSortType.public_icon}
                    onClick={handleClick}
                />
            </Tooltip>
        )
}

DefaultColumnSortingIndicator.propTypes = {
    // database id of column object
    columnId: PropTypes.number.isRequired,
    // sheet key
    id: PropTypes.number.isRequired,
    // this is the sort enum
    defaultSortType: PropTypes.number.isRequired,
    // action creator
    toggleDefaultSortOnColumn: PropTypes.func.isRequired,
}

export default DefaultColumnSortingIndicator
